import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";

export function useLogisticaDialogColumns() {
  const UMEInitialColumns = [
    { headerName: "Mes - Año", field: "mesAnio", flex: 70 },
    { headerName: "Cantidad dieta", field: "cantidadDieta", flex: 70 },
    {
      headerName: "Cantidad suministro",
      field: "cantidadSuministro",
      flex: 70,
    },
    {
      headerName: "Cantidad porcentaje",
      field: "cantidadPorcentaje",
      flex: 70,
    },
  ];

  const contratosInitialColumns = [
    { headerName: "Contrato", field: "idEvaluacion", flex: 70 },
    { headerName: "Mes - Año	", field: "mesAnio", flex: 70 },
    { headerName: "Fecha desde", field: "fechaDesde", type: "date", flex: 70 },
    { headerName: "Fecha hasta", field: "fechaHasta", type: "date", flex: 70 },
    { headerName: "CX reales", field: "conexionReal", flex: 70 },
    { headerName: "CX teóricas", field: "conexionTeorica", flex: 70 },
    { headerName: "CX porcentaje", field: "conexionPorcentaje", flex: 70 },
    { headerName: "Plan", field: "planCuidado", flex: 70 },
  ];

  const enviosInitialColumns = [
    { headerName: "CodSapVenta", field: "codigoSapVenta", flex: 70 },
    {
      headerName: "Fecha entrega	",
      field: "fechaEntrega",
      type: "date",
      flex: 70,
    },
    {
      headerName: "Fecha remito",
      field: "fechaRemito",
      type: "date",
      flex: 70,
    },
    { headerName: "ID insumo", field: "idInsumo", flex: 70 },
    { headerName: "Insumo", field: "descripcionInsumo", flex: 70 },
    { headerName: "Cantidad", field: "cantidad", flex: 70 },
    { headerName: "UME", field: "uME", flex: 70 },
    { headerName: "Tipo pedido", field: "tipoPedido", flex: 70 },
  ];

  const UMEcolumns = generateColumnsDefaultConfiguration(
    UMEInitialColumns,
    true
  );
  const contratosColumns = generateColumnsDefaultConfiguration(
    contratosInitialColumns,
    true
  );
  const enviosColumns = generateColumnsDefaultConfiguration(
    enviosInitialColumns,
    true
  );

  return { UMEcolumns, contratosColumns, enviosColumns };
}
